
const LayersIcon = ({fill = '#4A4A4A'}) => {
    return (
        <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.2105 17.6968L6.02602 13.0958L14.2121 8.54858L22.1756 13.0788L14.2105 17.6968Z" stroke={fill} strokeWidth="1.76471" />
            <path d="M4 16.1871L14 21.8088L23.73 16.1675" stroke={fill} strokeWidth="1.76471" strokeLinecap="round" />
        </svg>
    )
}
export default LayersIcon;
